import React, { useEffect, useRef, useState } from "react";
import { FaPlay } from "react-icons/fa";
import { FaPause } from "react-icons/fa6";
import Cookies from "js-cookie";
const apiUrl = process.env.REACT_APP_API_URL;

// Translations for English, Hindi, and Kannada
const translations = {
  en: {
    header: "Profession/ Occupation",
    required: "*",
    errorSelectOption: "Please select an option before proceeding.",
    ok: "OK",
    moveError:"Please answer the current question before proceeding to the next one.",
  },
  Hi: {
    header: "पेशा/ व्यवसाय",
    required: "*",
    errorSelectOption: "कृपया आगे बढ़ने से पहले एक विकल्प चुनें।",
    moveError:"कृपया अगले प्रश्न पर जाने से पहले वर्तमान प्रश्न का उत्तर दें।",
    ok: "ठीक है",
  },
  Kn: {
    header: "ವೃತ್ತಿ/ ಉದ್ಯೋಗ",
    required: "*",
    errorSelectOption: "ದಯವಿಟ್ಟು ಮುಂದುವರೆಯುವ ಮೊದಲು ಆಯ್ಕೆಮಾಡಿ.",
    moveError:"ದಯವಿಟ್ಟು ಮುಂದಿನ ಪ್ರಶ್ನೆಗೆ ಹೋಗುವ ಮೊದಲು ಪ್ರಸ್ತುತ ಪ್ರಶ್ನೆಗೆ ಉತ್ತರ ನೀಡಿ.",
    ok: "ಸರಿ",
  },
};

const Profession = ({
  onNext,
  onVictimProfessionSelected,
  onQuestion,
  answer,
  apiKey,
  botToken,
  vist_id,
  app_ver,
  selectedLang
}) => {
  const [Profession, setProfession] = useState(null);
  const [showOkButton, setShowOkButton] = useState(true);
  const [rawProfessionData, setRawProfessionData] = useState(null);
  const [error, setError] = useState(null);
  const [professionOptions, setProfessionOptions] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false); // Audio play status
  const audioRef = useRef(null);
  // Mapping language codes to audio source files
  const audioMap = {
    en: "audio/English BOT Audios/profession.mp3",
    Hi: "audio/Hindi BOT Audios/Hindi-Audio9.mp3",
    Kn: "audio/Kannada BOT Audios/Kannada-Audio9.m4a",
    tcy: "audio/cybervictim_tcy.mp3",
  };



  // When the selected language changes, update the audio element's source automatically
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.src = audioMap[selectedLang] || audioMap["en"];
      audioRef.current.load();
      if (isPlaying) {
        audioRef.current.play();
      }
    }
  }, [selectedLang, isPlaying]);

       useEffect(() => {
           const handler = () => {
            if (audioRef.current) {
               audioRef.current.pause();
               audioRef.current.currentTime = 0;
                setIsPlaying(false);
              }
            };
            window.addEventListener('pauseAllAudio', handler);
            return () => window.removeEventListener('pauseAllAudio', handler);
          }, []);

  // Retrieve stored Profession value (if any) from localStorage on mount
  useEffect(() => {
    const storedData = localStorage.getItem("Profession");
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      setProfession(parsedData);
      onVictimProfessionSelected(parsedData);
    }
  }, []);


  const getProfessionList = (resp, language) => {
    switch (language) {
      case "en":
        return resp.lang_eng;
      case "Hi":
        return resp.lang_hin;
      case "Kn":
        return resp.lang_kanada;
      default:
        return resp.lang_eng; // fallback
    }
  };


  useEffect(() => {
    if (rawProfessionData) {
      const ProfessionList = getProfessionList(rawProfessionData, selectedLang) || [];

      const generateId = (index) => {
        if (index < 26) {
          // For index 0-25, use uppercase letters A-Z.
          return String.fromCharCode(65 + index);
        } else if (index < 52) {
          // For index 26-51, use lowercase letters a-z.
          return String.fromCharCode(97 + index - 26);
        } else {
          // Fallback to numeric or combined identifiers if more than 52 items.
          return index.toString();
        }
      };
      setProfessionOptions(
        ProfessionList.map((profession, index) => ({
          //id: String.fromCharCode(65 + index),
          id: generateId(index),
          value: profession.prof_uniq,
          label: profession.prof_nm,
        })) || []
      );
    }
  }, [selectedLang, rawProfessionData]);
  // Fetch profession options from API
  useEffect(() => {
    const fetchProfessionData = async () => {
      try {
        const ProfessionResponse = await fetch(
          `${apiUrl}/v1/cy_ma_profesion_list`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              api_key: apiKey,
              visitor_token: vist_id,
              qtion_id: "66f65342db514",
              lac_token: botToken,
              app_ver: app_ver,
              bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
            }),
          }
        );

        if (!ProfessionResponse.ok) {
          throw new Error("Failed to fetch profession options");
        }

        const ProfessionData = await ProfessionResponse.json();
        if (ProfessionData.resp.error_code === "0") {
          setRawProfessionData(ProfessionData.resp);
          // const ProfessionList = getProfessionList(ProfessionData.resp, selectedLang) || [];
          // setProfessionOptions(
          //   ProfessionList.map((profession, index) => ({
          //     id: String.fromCharCode(65 + index),
          //     value: profession.prof_uniq,
          //     label: profession.prof_nm,
          //   })) || []
          // );
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchProfessionData();
  }, [apiKey, app_ver, botToken, vist_id]);

  const handleOptionClick = async (option, e) => {
    e.preventDefault();
    if (option.disabled) {
      return;
    }
    // Update selected Profession (using the label)
    setProfession(option.label);
    try {
      const response = await fetch(`${apiUrl}/v1/ccrim_bot_add_choice`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          visitor_token: vist_id,
          qtion_id: "66f65342db514",
          qtion_num: "7",
          qtion_option: option.id,
          option_val: option.value,
          lac_token: botToken,
          app_ver: app_ver,
          bot_lang_id: selectedLang=== "en" ? "2" : selectedLang === "Hi" ? "3" : selectedLang === "Kn" ? "1" : "4",
        }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error("Failed to push data to API");
      }

      if (data.resp.error_code === "0") {
        if (audioRef.current && isPlaying) {
          audioRef.current.pause();
          setIsPlaying(false);
        }
        setProfession(option.label);
        onVictimProfessionSelected(option.label);
        setShowOkButton(true);
        onNext(9);
        onQuestion(10);
        localStorage.setItem("Profession", JSON.stringify(option.label));
        setError("");
      } else {
        setError("Failed to push data to API");
      }
    } catch (err) {
      console.error("Error sending data to API:", err);
    }
  };

  const handleOkClick = (e) => {
    if (audioRef.current && isPlaying) {
      audioRef.current.pause();
      setIsPlaying(false);
    }
    if (Profession) {
      onNext(9);
      onQuestion(10);
    } else {
      setError('errorSelectOption');
      setShowOkButton(false);
    }
  };

  const toggleAudio = (e) => {
    e.preventDefault();
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
        setIsPlaying(false);
      } else {
        audioRef.current.play();
        setIsPlaying(true);
      }
    }
  };

  const handleAudioEnd = () => {
    setIsPlaying(false);
  };

  return (
    <div className="question">
      <div style={{ display: "flex" }}>
        <div>
          <div style={{ display: "flex" }}>
            <h2>
              {translations[selectedLang].header}{" "}
              <span style={{ color: "red" }}>
                {translations[selectedLang].required}
              </span>
            </h2>
            <button onClick={toggleAudio} className="audio-button">
              {isPlaying ? <FaPause color="White" size={12} style={{ marginBottom: '20px' }} /> : <FaPlay color="White" size={12} style={{ marginBottom: '20px' }}/>}
            </button>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd}>
            <source src={audioMap[selectedLang]} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div
            className="option-list"
            style={{ position: "relative", zIndex: "9" }}
          >
            {professionOptions.map((option) => (
              <button
                key={option.id}
                className={`option-button ${
                  Profession === option.label ? "selected" : ""
                }`}
                onClick={(e) => handleOptionClick(option, e)}
              >
                <div className="answer-container">
                  <div
                    className="option"
                    style={{
                      backgroundColor:
                        Profession === option.label ? "#000" : "#fff",
                      color: Profession === option.label ? "#fff" : "#000",
                    }}
                  >
                    {option.id}
                  </div>
                  <div className="option-label">{option.label}</div>
                </div>
                {Profession === option.label && (
                  <span className="checkmark">&#10003;</span>
                )}
              </button>
            ))}
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              zIndex: "9",
            }}
          >
            {showOkButton && (
              <button type="button" className="ok-btn" onClick={handleOkClick}>
                {translations[selectedLang].ok}
              </button>
            )}
          </div>
          {error && (
            <div
              className="error-message"
              style={{ position: "relative", zIndex: "1000" }}
            >
              {translations[selectedLang][error]}
            </div>
          )}
          {answer[8] && (
            <p className="alert-box">
              {translations[selectedLang].moveError}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profession;
